import { Component, Input, OnInit } from '@angular/core';
import { Form } from 'src/app/_model/forms';

@Component({
  selector: 'app-forms-concentraions',
  templateUrl: './forms-concentraions.component.html',
  styleUrls: ['./forms-concentraions.component.scss']
})
export class FormsConcentraionsComponent implements OnInit {
@Input() forms: Form[];
  constructor() { }

  ngOnInit(): void {
  }

}
